import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import MainPage from '../components/pages/MainPage.vue';

Vue.use(VueRouter)

export const routes: Array<RouteConfig> = [
    // {
    //     path: '/',
    //     name: 'Home',
    //     component: () => import('@/components/pages/HomePage.vue'),
    // },
    {
        path: '/',
        name: 'Main',
        component: () => import('@/components/pages/MainPage.vue'),
    },
    {
        path: '/blog',
        name: 'Blog',
        component: () => import('@/components/pages/BlogPage.vue'),
    },
    {
        path: '/*',
        redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

export default router
